export default __webpack_public_path__ + "f3a59692120a009b0e39a0c06fbad399.svg";